import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import SignupService from 'cio/services/signup';

export default class PostRegistrationRole extends Route {
  @service signup!: SignupService;

  async model({ signupType }: { signupType: string }) {
    let validatedSignupType = await this.signup.validateSignupType.perform(signupType);

    return {
      signupType: validatedSignupType,
    };
  }
}
